import { Types } from 'mongoose';
import { IAccountOwned } from './account';

export type SelectorNodeId = string;
export type SelectorOptionId = string;
export type ProductId = string;

export interface IProductSelectorTemplate extends IAccountOwned {
  _id: Types.ObjectId;
  name: string;
  tree: IProductSelectorTree;
  isArchived: boolean;
}

export interface IProductSelectorTree {
  rootNodeId: SelectorNodeId;
  nodes: Record<SelectorNodeId, ISelectorNode>;
}

export interface ISelectorNode {
  id: SelectorNodeId;
  prompt: string;
  options: ISelectorOption[];
}

export interface ISelectorOption {
  id: SelectorOptionId;
  label: string;
  description?: string;
  next: SelectorNext;
  sortOrder?: number;
}

export type SelectorNext =
  | { type: 'none' }
  | { type: 'node'; nodeId: SelectorNodeId }
  | { type: 'product'; productId: ProductId };

export interface ISelectorValidationResult {
  valid: boolean;
  errors: ISelectorValidationMessage[];
  warnings: ISelectorValidationMessage[];
}

export interface ISelectorValidationMessage {
  code: SelectorValidationCode;
  message: string;
  nodeId?: SelectorNodeId;
  optionId?: SelectorOptionId;
  productId?: ProductId;
}

export enum SelectorValidationCode {
  RootNodeMissing = 'ROOT_NODE_MISSING',
  NodeRefInvalid = 'NODE_REF_INVALID',
  ProductRefInvalid = 'PRODUCT_REF_INVALID',
  CycleDetected = 'CYCLE_DETECTED',
  TreeEmpty = 'TREE_EMPTY',
  OrphanNode = 'ORPHAN_NODE',
  DeadEndNode = 'DEAD_END_NODE',
  OptionNotConnected = 'OPTION_NOT_CONNECTED',
}
